var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{attrs:{"url":"schedules","columns":_vm.columns,"title":_vm.title,"sortOptions":{
    enabled: true,
    field: 'dateCreated',
    type: 'desc',
  },"expandedOptions":{
    enabled: true,
    template: 'schedule-details',
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }